module.exports = __webpack_public_path__ + "static/media/clone-img.7cb92fbd.svg";